module.exports = __webpack_public_path__ + "static/media/26-6.77103c39.mp3";